var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3a92628c1a8c5a402fa78c57f34a9400",
    "data-name": "3a92628c1a8c5a402fa78c57f34a9400",
    d: "M47.139,18.435a18.863,18.863,0,0,1,.47,4.115c0,10.878-9.263,19.946-21.459,21.894A22.879,22.879,0,0,0,34.7,46.088a23.135,23.135,0,0,0,8.12-1.459A29.777,29.777,0,0,0,52.2,45.97a23.979,23.979,0,0,1-3.222-5,14.151,14.151,0,0,0,5.071-10.558C54.052,25.6,51.358,21.31,47.139,18.435ZM2.452,41.4a1.7,1.7,0,0,0,1.5.9.627.627,0,0,0,.081,0c1.788-.084,5.345-1.267,9.11-3.65a75,75,0,0,0,8.1,1.021c11.889,0,21.2-8.253,21.2-18.79,0-10.362-9.506-18.79-21.2-18.79S.052,10.513.052,20.875A17.785,17.785,0,0,0,5.931,33.845a25.079,25.079,0,0,1-3.32,5.742,1.684,1.684,0,0,0-.159,1.81Zm.98-20.522c0-8.5,7.991-15.42,17.819-15.42S39.07,12.373,39.07,20.875c0,8.789-7.66,15.42-17.819,15.42a77.64,77.64,0,0,1-8.11-1.078,1.7,1.7,0,0,0-1.281.246,28.321,28.321,0,0,1-4.006,2.214,28.508,28.508,0,0,0,1.67-3.757,1.687,1.687,0,0,0-.514-1.87A14.379,14.379,0,0,1,3.432,20.875Z",
    transform: "translate(-0.052 -2.088)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueries);
export default __webpack_public_path__ + "static/media/Queries.39e7d57a875c385e05e429c8eb2f0595.svg";
export { ForwardRef as ReactComponent };